import { render } from "./quote_card_content.vue?vue&type=template&id=0e5af579"
import script from "./quote_card_content.vue?vue&type=script&lang=js"
export * from "./quote_card_content.vue?vue&type=script&lang=js"

import exportComponent from "M:\\Viridian Patriots\\Server\\pleroma-fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__